import React from 'react';
import { useNotificationHandler } from 'hooks/useNotificationHandler';

export const exportChartAsSVG = ( chartRef, notificationHandler ) => {
    const {
        notifySuccess,
        notifyError,
        notifyLoading,
        closeNotification
    } = notificationHandler;
    const exportKey = notifyLoading('Exporting Chart', 'Preparing SVG file for download...');

    try {
        const svg = chartRef.current.querySelector('svg');
        const svgData = new XMLSerializer().serializeToString(svg);
        const svgBlob = new Blob([svgData], { type: 'image/svg+xml;charset=utf-8' });
        const svgUrl = URL.createObjectURL(svgBlob);

        const downloadLink = document.createElement('a');
        downloadLink.href = svgUrl;
        downloadLink.download = 'time-series-chart.svg';

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        closeNotification(exportKey);
        notifySuccess('Export Complete', 'Chart has been exported as SVG successfully');

    } catch (error) {
        closeNotification(exportKey);
        notifyError('Export Failed', 'There was a problem exporting the chart');
        console.error('Error exporting chart:', error);
    }
};

export const exportChartDataAsCSV = ( chartData, notificationHandler ) => {
    const {
        notifySuccess,
        notifyError,
        notifyLoading,
        closeNotification
    } = notificationHandler;

    if (chartData.length === 0) {
        notifyError('No Data', 'There is no chart data to export');
        return;
    }

    const exportKey = notifyLoading('Exporting Data', 'Preparing CSV file for download...');

    try {
        // Obtener todas las claves únicas excepto 'name' y 'undefined'
        const keys = Object.keys(
            chartData.reduce((acc, curr) => {
                Object.keys(curr).forEach(key => {
                    if (key !== 'date' && key !== 'dateObject' && key !== 'undefined') acc[key] = true;
                });
                return acc;
            }, {})
        );

        // Agregar 'name' al principio para que sea el primer encabezado (la fecha u otro valor clave)
        const allKeys = ['date', ...keys];

        // Crear encabezados para las columnas
        const headers = allKeys.join(',') + '\n';

        // Convertir los datos en formato CSV asegurando que cada fila tenga los mismos valores en el mismo orden
        const csvContent = chartData.map(row => {
            return allKeys.map(key => row[key] ?? '').join(',');
        }).join('\n');

        // Unir encabezados y datos
        const csv = headers + csvContent;

        // Crear un archivo Blob con los datos CSV
        const csvBlob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const csvUrl = URL.createObjectURL(csvBlob);

        // Crear un enlace de descarga
        const downloadLink = document.createElement('a');
        downloadLink.href = csvUrl;
        downloadLink.download = 'time-series-data.csv';

        // Ejecutar la descarga
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        closeNotification(exportKey);
        notifySuccess('Export Complete', 'Data has been exported as CSV successfully');
    } catch (error) {
        closeNotification(exportKey);
        notifyError('Export Failed', 'There was a problem exporting the data');
        console.error('Error exporting data:', error);
    }
};